import { render, staticRenderFns } from "./EdenPointReport.vue?vue&type=template&id=630950b3&"
import script from "./EdenPointReport.vue?vue&type=script&lang=js&"
export * from "./EdenPointReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports